<template>
  <flow-part :id="$options.name">
    <template #heading />
    <template #content>
      <div v-if="orderStore.product.tariff_type === 'dynamic' || orderStore.product.tariff_type === 'dynamic_gas_fixed'"
        class="required-notice">
        Je hebt gekozen voor een dynamisch contract.<br><br>
        Een werkende <strong>slimme meter</strong> is verplicht bij dit contract.
        Heb je een niet-slimme meter, dan kun je dit contract helaas niet afsluiten.
        <hr v-if="orderStore.product.confirmations.length > 0">
      </div>

      <!-- These opt_ins need to be created dynamically per product/provider, the values/labels can be retrieved from the product itself -->

      <template v-for="confirmation in orderStore.product.confirmations" :key="confirmation.slug">
        <div v-if="confirmation.required && confirmation.position !== 'contact'" class="required-notice">
          {{ confirmation.label }}
        </div>
      </template>

      <template v-for="confirmation in orderStore.product.confirmations" :key="confirmation.slug">
        <template v-if="confirmation.position !== 'contact'">
          <checkbox-input v-if="!confirmation.required" :id="confirmation.slug"
            v-model="orderStore.opt_ins[confirmation.slug]">
            {{ confirmation.label }}
          </checkbox-input>
        </template>
      </template>


      <!-- Submit button -->

      <div class="confirm-container">
        <div class="terms-summary">
          Door aan te melden ga je akkoord met de <a href="#" @click.prevent="toggleTerms()">voorwaarden</a>
          en sluit je een betalingsovereenkomst met {{ newProvider }}.
        </div>

        <k-button :class="{ loading: orderStore.loading }" @submit="submitForm()">
          <template #content>
            Bevestig je aanvraag
            <div class="cta-loaderbar-container">
              <div class="loaderbar"></div>
            </div>
          </template>
        </k-button>
      </div>

      <section class="submit-error">

        <FieldError v-if="orderStore.errors.general" :error="orderStore.errors.general" />
      </section>

      <section v-show="showTerms" class="terms tip">
        <ul>
          <li v-for="(term, index) in orderStore.product.terms" :key="index">
            <a :href="term.url" target="_blank"> {{ term.name }} </a>
          </li>
        </ul>
      </section>

      <div class="redemption-notice">
        Binnen twee dagen krijg je een bevestiging van {{ orderStore.product.provider_name }}. Hierna heb je 14 dagen
        bedenktijd.
        Tijdens de bedenktijd kun je jouw aanvraag kosteloos annuleren.
      </div>

    </template>
  </flow-part>
</template>

<script>
import CheckboxInput from 'vue-elements/input/CheckboxInput.vue';
import FieldError from 'vue-elements/field/FieldError.vue';
import FormPartMixin from '../../lib/FormPartMixin';
import KButton from '../../../../../abstracts_depr/elements/button/button.vue';
import FlowPart from '../FlowPart.vue';
import { useOrderStore } from '../../stores/orderStore.js';
import { logAnalyticsEvent } from '../../../../../assets/js/helpers/bananas.js';

export default {
  name: 'DisclaimerPart',
  mixins: [FormPartMixin()],
  components: {
    FieldError,
    CheckboxInput,
    FlowPart,
    KButton,
  },
  setup() {
    const orderStore = useOrderStore();

    return {
      orderStore,
    };
  },
  data() {
    return {
      showTerms: false,
    };
  },
  computed: {
    newProvider() {
      return this.orderStore.product.provider_name;
    },
  },
  methods: {
    submitForm() {
      if (!this.orderStore.loading) {
        this.$emit('submit');
      }
    },
    toggleTerms() {
      logAnalyticsEvent('compare-energy.order-toggle-terms');
      this.showTerms = !this.showTerms;
    },
  },
};
</script>
<style lang="scss">
@use 'assets/scss/all' as *;

#DisclaimerPart {
  border-top: 0;
  padding-top: 0;
}

#DisclaimerPart .checkbox-element {
  label {
    font-weight: normal;
  }

  input:disabled+label span {
    color: #171717 !important;
  }
}

.cta-loaderbar-container {
  display: none;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.confirm-container {
  .cta {
    margin: 0 !important;
    white-space: nowrap;
    padding: 18px 26px !important;

    grid-row-start: 1;

    @include breakpoint-up(md) {
      grid-row-start: 1;
      grid-column-start: 2;
    }

    span.label {
      font-size: 17px !important;
      font-weight: 600 !important;
      line-height: inherit !important;
    }

    position: relative;
    // overflow: hidden;

    &.loading {
      .cta-loaderbar-container {
        display: block;
        background: rgba(255, 255, 255, .5);
        overflow: hidden;
        border-radius: 15px;

        .loaderbar {
          position: absolute;
          top: 58px;
          right: 100%;
          bottom: 0;
          left: 0;
          height: 5px;
          background: rgba(0, 0, 0, .33);
          width: 0;
          animation: borealisBar 2s linear infinite;
          z-index: 10;
        }
      }
    }
  }

}

@keyframes borealisBar {
  0% {
    left: 0%;
    right: 100%;
    width: 0%;
  }

  10% {
    left: 0%;
    right: 80%;
    width: 30%;
  }

  90% {
    right: 0%;
    left: 90%;
    width: 80%;
  }

  100% {
    left: 100%;
    right: 0%;
    width: 0%;
  }
}
</style>
<style scoped lang="scss">
@use 'assets/scss/all' as *;

.redemption-notice {
  font-size: 14px;
  padding: 30px 16px;
  padding-left: 4px;
  padding-bottom: 0;
  color: #3F7182;
  line-height: 1.3em;
}

.redemption-notice,
.confirm-container {
  @include breakpoint-up(lg) {
    margin-right: -120px;
    grid-gap: 24px;
    margin-left: 4px;
  }
}

.confirm-container {
  display: grid;

  grid-template-columns: 1fr;


  grid-gap: 16px;
  border-radius: 20px;

  align-items: center;
  justify-content: space-between;

  background: $grey-10;
  border: 1px solid $border-base;

  padding: 16px;

  @include breakpoint-up(md) {
    grid-template-columns: auto 1fr;
  }

  .terms-summary {
    @include paragraph-15;
  }


}

:deep(button.cta.loading) {
  pointer-events: none;
  cursor: not-allowed;

  &:focus {
    box-shadow: none;
  }

  .icon-element {
    transition: transform linear 5s;
    transform: rotate(720deg);
  }
}

.checkbox-field {
  display: flex;
  align-items: flex-start;
  line-height: 150%;
}

.checkbox-input-field {
  margin: 24px 0;
}

.terms-toggle {
  color: $link-base-default;

  &:hover {
    color: $link-base-hover;
    text-decoration: underline;
  }
}

.confirm-container {
  .cta {
    width: 100%;
    font-weight: 500;
    margin-top: 32px;

    @include breakpoint-up(md) {
      margin-top: 48px;
      max-width: 312px;
    }
  }
}

.required-notice {
  font-size: 15px;
  color: #3F7182;
  line-height: 1.4em;
  padding-left: 8px;
  margin-top: -24px;
  margin-bottom: 32px;
}
</style>
